module.exports = __webpack_public_path__ + "static/media/Pedidos8.0e16438d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancPedidos/Pedidos8.png
// module id = 1786
// module chunks = 0